import React, { useCallback, useRef } from 'react'
import styled from 'styled-components'
import useToggle from 'hooks/useToggle'

import Breakpoint from 'components/Common/Breakpoint'
import TextButton from 'components/Luxkit/Button/TextButton'
import DropdownChevron from 'components/Luxkit/Dropdown/DropdownChevron'
import LineMapMarkerIcon from 'components/Luxkit/Icons/line/LineMapMarkerIcon'
import Dropdown from 'components/Luxkit/Dropdown'
import ListItem from 'components/Luxkit/List/ListItem'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import Modal from 'components/Luxkit/Modal/Modal'

const Root = styled.div`
  position: relative;
`

interface Props {
  selected: App.AllAirport;
  locations: Array<App.AllAirport>;
  className?: string;
  onChangeLocation: (location: App.AllAirport) => void;
}

function LocationSelect(props: Props) {
  const triggerRef = useRef()
  const { selected, locations, className, onChangeLocation } = props
  const { value: menuOpen, toggle: toggleMenu, off: closeMenu } = useToggle()

  const onSelectLocation = useCallback((e: React.MouseEvent<HTMLElement>) => {
    const location = locations.find(({ code }) => code === e.currentTarget.dataset.code)
    onChangeLocation(location)
    closeMenu()
  }, [locations, closeMenu, onChangeLocation])

  const content = locations.map(({ code, name }) =>
    <ListItem
      key={code}
      size="medium"
      title={name}
      data-code={code}
      onClick={onSelectLocation}
    />,
  )

  return (
    <Root className={className}>
      <TextButton
        ref={triggerRef}
        kind="secondary"
        startIcon={<LineMapMarkerIcon />}
        endIcon={<DropdownChevron size="XS" open={menuOpen} />}
        onClick={toggleMenu}
      >
        {selected.name}
      </TextButton>

      <Breakpoint max="xs">
        <Modal
          isOpen={menuOpen}
          title="Departing from"
          onClose={closeMenu}
        >
          {content}
        </Modal>
      </Breakpoint>

      <Breakpoint min="sm">
        <Dropdown
          open={menuOpen}
          triggerRef={triggerRef}
          caretType="none"
          onClose={closeMenu}
        >
          <DropdownContainer fit="dropdown-items">
            {content}
          </DropdownContainer>
        </Dropdown>
      </Breakpoint>
    </Root>
  )
}

export default LocationSelect
